<div class="card mb-4">
    <!-- Skeleton para evitar shift -->
    <div *ngIf="displayAguarde">
        <p-skeleton height="40px" width="100%"></p-skeleton>
        <div class="mb-2 mt-4"></div>
        <p-skeleton height="40px" width="100%"></p-skeleton>
        <div class="mb-2 mt-4"></div>
        <p-skeleton height="40px" width="100%"></p-skeleton>
        <div class="mb-2 mt-4"></div>
        <p-skeleton height="40px" width="100%"></p-skeleton>
    </div>



    <div *ngIf="!displayAguarde">
        <div class="flex align-items-center cursor-pointer" [class.mb-3]="!collapsed.ttMain" (click)="toggle('ttMain')"
            pRipple>
            <i class="bi bi-tiktok mr-2" style="font-size: 2rem;"></i>
            <div>
                <div class="font-bold">TikTok</div>
                <div class="text-sm text-500">{{ getMainText() }}</div>
            </div>
            <i class="pi pi-fw pi-angle-down ml-auto transition-transform"
                [ngClass]="{ 'rotate-180': !collapsed.ttMain }"></i>
        </div>
    </div>

    <div class="collapsible" [class.collapsed]="collapsed.ttMain" *ngIf="showConectAccount && !displayAguarde">
        <div class="collapsible__inner">
            <div class="" *ngIf="showConectAccount && !displayAguarde">
                <div class="card cursor-pointer border-dashed border-1 surface-border flex flex-column justify-content-center align-items-center ss-g-hover-border2 text-center shadow-none"
                    style="height:160px;" (click)="conectTikTok()">
                    <img src="assets/tiktok.webp" width="36" class="mb-3" />
                    <span class="font-medium">Conectar conta do TikTok</span>
                    <span class="text-sm text-500">Conecte uma conta do TikTok para começar</span>
                </div>
            </div>
        </div>
    </div>

    <div class="collapsible" [class.collapsed]="collapsed.ttMain" *ngIf="!showConectAccount && !displayAguarde">
        <div class="collapsible__inner">
            <p-dropdown *ngIf="!showConectAccount && !displayAguarde" [appendTo]="'body'" [options]="tiktokAccountsOptions"
                [(ngModel)]="selectedTikTokOpenId" optionLabel="label" (onChange)="onSelectTikTokAccount($event.value)"
                optionValue="value" placeholder="-- selecione --">
                <ng-template let-o pTemplate="item">
                    <div class="flex align-items-center">
                        <ng-container *ngIf="o.value !== 'add_account'; else addAccountItem">
                            <img [src]="o.picture" width="24" class="mr-2" />
                            {{ o.label }}
                        </ng-container>
                        <ng-template #addAccountItem>
                            <i class="pi pi-plus mr-2"></i>
                            {{ o.label }}
                        </ng-template>
                    </div>
                </ng-template>
                <ng-template let-o pTemplate="selectedItem">
                    <div class="flex align-items-center">
                        <ng-container *ngIf="o.value !== 'add_account'; else addAccountSelected">
                            <img [src]="o.picture" width="24" class="mr-2" />
                            {{ o.label }}
                        </ng-container>
                        <ng-template #addAccountSelected>
                            <i class="pi pi-plus mr-2"></i>
                            {{ o.label }}
                        </ng-template>
                    </div>
                </ng-template>
            </p-dropdown>

            <div class="flex align-items-center mt-3 mb-3"
                *ngIf="!showConectAccount && showAutoPublish && !displayAguarde">
                <p-inputSwitch [(ngModel)]="autoPublish" (onChange)="onToggleAutoPublish($event.checked)"
                    styleClass="mr-3"></p-inputSwitch>
                <div>
                    <div class="font-semibold text-lg">Auto-publicar</div>
                    <div class="text-sm text-500">Publicar mídias capturadas</div>
                </div>
            </div>

            <p-tabMenu [model]="tabs" [activeItem]="activeTab" *ngIf="!showConectAccount && !displayAguarde"
                class="mb-4"></p-tabMenu>

            <div class="mt-2 text-sm text-500" *ngIf="!showConectAccount && !displayAguarde">Liste os vídeos da sua conta.</div>

            <button *ngIf="showContent && !showConectAccount && !displayAguarde" pButton type="button"
                class="mt-4 w-full" [disabled]="LoadSearching" (click)="loadMoreTikTokVideos(true)">
                <ng-container *ngIf="LoadSearching; else searchIconTikTok">
                    <i class="pi pi-spinner pi-spin mr-2"></i>
                </ng-container>
                <ng-template #searchIconTikTok>
                    <i class="pi pi-search mr-2"></i>
                </ng-template>
                <span style="flex: 1 1 0; text-align: center;" class="p-button-label">Buscar</span>
            </button>

        </div>
    </div>




</div>
<div class="card mb-0" *ngIf="!displayAguarde && !isFeed">
    <!-- HEADER TikTok: Extrair via URL -->
    <div *ngIf="!displayAguarde">
        <div class="flex align-items-center cursor-pointer" [class.mb-3]="!collapsed.ttExtract"
            (click)="toggle('ttExtract')" pRipple>
            <i class="bi bi-tiktok mr-2" style="font-size: 2rem;"></i>
            <div>
                <div class="font-bold">TikTok</div>
                <div class="text-sm text-500">Importar via URL (mídia deve ser PÚBLICA)</div>
            </div>
            <i class="pi pi-fw pi-angle-down ml-auto transition-transform"
                [ngClass]="{ 'rotate-180': !collapsed.ttExtract }"></i>
        </div>
    </div>

    <!-- CONTEÚDO TikTok: Extrair -->
    <div *ngIf="!displayAguarde" [class.mb-4]="!collapsed.ttExtract">
        <div class="collapsible" [class.collapsed]="collapsed.ttExtract">
            <div class="collapsible__inner">

                <div class="p-inputgroup mt-2 w-full">
                    <span class="p-inputgroup-addon"><i class="pi pi-link"></i></span>
                    <input pInputText class="w-full" [(ngModel)]="tiktokUrl"
                        placeholder="Cole a URL do TikTok" (ngModelChange)="checkTiktokUrl()"/>
                </div>
                <div class="flex justify-between items-center mt-1 text-sm">
                    <small class="p-error mr-2 w-full"
                      [ngStyle]="{ visibility: tiktokInvalid ? 'visible' : 'hidden' }">
                      URL do TikTok inválida!
                    </small>
                  </div>

                <button pButton type="button" class="w-full mt-4" [disabled]="!tiktokUrl || extractingTikTok || tiktokInvalid"
                    (click)="extractTikTok(true)">
                    <ng-container *ngIf="extractingTikTok; else extractIconTt">
                        <i class="pi pi-spinner pi-spin mr-2"></i>
                    </ng-container>
                    <ng-template #extractIconTt>
                        <i class="pi pi-download mr-2"></i>
                    </ng-template>
                    <span class="p-button-label" style="flex: 1 1 0; text-align: center;">Extrair</span>
                </button>

            </div>
        </div>
    </div>

</div>




<div class="mt-4" *ngIf="showContent && !displayAguarde">
    <div *ngIf="hasSearchedTikTok">
        <p-dataView [value]="formattedTikTokVideos" layout="grid" [rows]="20">
            <ng-template pTemplate="gridItem" let-video>
                <div class="col-12 sm:col-6 md:col-6 lg:col-6">
                    <div class="dv-item relative">

                        <!-- Checkbox -->
                        <div class="absolute left-1 top-1 z-2">
                            <p-checkbox [binary]="true" [ngModel]="isSelected(video)"
                                (onChange)="toggleSelection(video)">
                            </p-checkbox>
                        </div>

                        <div class="card m-0 p-0 border-round shadow-none s-s-l-minH">
                            <!-- <img [src]="video.thumbnail_url"
                                class="w-full h-60 object-cover border-bottom-1 border-300" /> -->
                            <div class="tiktok-player" style="text-align: center;">
                                <iframe [src]="video.safe_player_url" frameborder="0"
                                    allow="autoplay; fullscreen; picture-in-picture" allowfullscreen>
                                </iframe>
                            </div>
                            <!-- <video [src]="video.embed_link"
                            ></video> -->

                            <div class="p-3">
                                <div class="text-700 text-sm mb-2 white-space-pre-line breakable"
                                    style="-webkit-box-orient: vertical; -webkit-line-clamp: 2; display: -webkit-box; overflow: hidden;">
                                    {{ video.caption }}
                                </div>

                                <span *ngIf="!extractedByUrl">
                                    … <a href="#" (click)="openDialog(video); $event.preventDefault()">ver mais</a>
                                </span>

                                <div class="text-xs text-500 mt-2">
                                    {{ video.timestamp | date:'dd MMM yyyy' }}
                                </div>

                                <a *ngIf="video.permalink" [href]="video.permalink" target="_blank"
                                    class="text-primary text-sm mt-1 block">
                                    Ver no TikTok
                                </a>
                            </div>
                        </div>
                    </div>
                </div>

            </ng-template>

            <ng-template pTemplate="empty">
                <div class="text-center text-600 mt-4">Nenhum vídeo encontrado.</div>
            </ng-template>
        </p-dataView>

    </div>
</div>

<app-dialog-aguarde [visible]="displayAguarde" [baseZIndex]="16000"></app-dialog-aguarde>